const MuiDialogActions = {
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '8px 24px',
  },
}

export default MuiDialogActions
